import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("D:/kandi/kandi-website/src/layouts/default.vue").then(m => m.default || m))
}